var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoLikeYet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "77px",
    viewBox: "0 0 87 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNoLikeYet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.3259642,0 C28.0552066,0 33.805488,2.25265675 38.1571396,6.75184401 L38.1571396,6.75184401 L43.3764639,12.1647147 L48.5958805,6.78033281 C57.2990914,-2.21823317 71.5261398,-2.21803261 80.2292584,6.78033281 C88.9324693,15.7787073 88.9324693,30.2306756 80.2292584,39.2290593 C68.385336,51.4747733 56.5467638,63.734162 44.7029337,75.9796026 C44.3543174,76.3437082 43.8693757,76.55 43.3620688,76.55 C42.854762,76.55 42.3698203,76.3437082 42.0212039,75.9796026 L42.0212039,75.9796026 L6.52367123,39.2005249 C4.04519802,36.6330698 2.27253576,33.6234502 1.20637731,30.4239561 C0.348788563,28.1754554 -0.0516542674,25.800886 0.0053228644,23.4350377 C-0.114020157,17.4209168 2.05765426,11.3692483 6.52367123,6.75184401 C10.8752305,2.25264763 16.5967218,0 22.3259642,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Likes-empty-state-no-statement",
    transform: "translate(-148.000000, -296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(74.000000, 296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icNoLikeYet",
    fill: "#666666",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoLikeYet);
export default __webpack_public_path__ + "static/media/icNoLikeYet.462902eb6078a6c53ab6292f23fdaccc.svg";
export { ForwardRef as ReactComponent };